// npm
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// material-ui
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';

// redux (selectors)
import { getExamData } from 'redux/reducers/selectors';
import { getFormRunGuid } from 'redux/reducers/exam/selectors';


const styles = ({ spacing }) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        marginTop: spacing.unit * 2,
    },
    card: {
        maxWidth: 480,
        textAlign: 'center',
    },
    button: {
        marginTop: 16,
    },
});


// CheckingReload (not connected to store)
// ----------------------------------------

class CheckingReload extends Component {

    componentDidMount() {
        const { formRunGuid, onComplete } = this.props;

        if (formRunGuid) {
            onComplete();
        }
    }

    render() {
        const { formRunGuid, classes, history } = this.props;

        if (formRunGuid) {
            return null;
        }

        return (
            <div className={classes.root}>
                <Card className={classes.card}>
                    <CardContent>
                        <Typography variant="body1">
                            This page has been reloaded. Your exam has already been submitted.
                        </Typography>
                        <Button
                            className={classes.button}
                            variant="contained"
                            color="primary"
                            onClick={() => history.push('/schedules')}
                        >
                            Go to Schedules
                        </Button>
                    </CardContent>
                </Card>
            </div>
        );
    }
}

CheckingReload.propTypes = {
    formRunGuid: PropTypes.string.isRequired,
    onComplete: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};


// CheckingReload (connected to store)
// ----------------------------------------

const mapStoreToProps = (store) => {
    const examData = getExamData(store);

    return {
        formRunGuid: getFormRunGuid(examData),
    };
};

CheckingReload = withStyles(styles)(CheckingReload);
CheckingReload = withRouter(CheckingReload);
CheckingReload = connect(mapStoreToProps)(CheckingReload);


// EXPORT
// ----------------------------------------
export { CheckingReload };
